<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg"
         width="16" 
         height="16" 
         :fill="stroke" 
         :class="svgClass"
         viewBox="0 0 16 16"
    >
        <path fill-rule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"/>
    </svg>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['strokeColor', 'strokeWidth', 'iconClass'])

const stroke = computed(() => {
    return props.strokeColor ? props.strokeColor : 'black'
})

const svgClass = computed(() => {
    return props.iconClass ? props.iconClass : 'w-2.5 h-2.5'
})

</script>